

















import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class TestA extends Vue {
    @Prop({ required: true }) loading!: boolean

    chartOptions = {
        chart: {
            height: '100%',
            width: '100%',
            type: 'area'
        },
        colors: [this.$vuetify.theme.currentTheme.primary],
        dataLabels: {
            enabled: false
        },
        toolbar: {
            theme: 'dark'
        },
        stroke: {
            curve: 'smooth'
        },
        xaxis: {
            type: 'datetime',
            labels: {
                style: {
                    colors: '#fff'
                }
            },
            categories: ['2018-09-19T00:00:00.000Z', '2018-09-19T01:30:00.000Z', '2018-09-19T02:30:00.000Z', '2018-09-19T03:30:00.000Z', '2018-09-19T04:30:00.000Z', '2018-09-19T05:30:00.000Z', '2018-09-19T06:30:00.000Z']
        },
        yaxis: {
            labels: {
                style: {
                    colors: '#fff'
                }
            }
        },
        legend: {
            labels: {
                colors: '#fff'
            }
        },
        tooltip: {
            theme: 'dark'
        }
    }

    series = [{
        name: 'Usage (%)',
        data: [31, 40, 28, 51, 42, 109, 100]
    }]
}
